export default {
  "metrics_select_metrics": "指标",
  "metrics_select_search_for_metrics": "搜索指标",
  "metrics_select_all": "全部",
}
